import { Skeleton, TableCell, TableRow, Table, TableBody, TableHead } from '@mui/material'

const TableSkeleton: React.FC = () => {
  const columnsConfig = [
    { width: '10%', rows: 5 },
    { width: '25%', rows: 12 },
    { width: '15%', rows: 12 },
    { width: '15%', rows: 10 },
    { width: '15%', rows: 7 },
    { width: '10%', rows: 7 },
    { width: '10%', rows: 8 }
  ]

  const maxRows = Math.max(...columnsConfig.map(col => col.rows))

  return (
    <Table sx={{ tableLayout: 'fixed' }}>
      <TableHead>
        <TableRow>
          {columnsConfig.map((col, index) => (
            <TableCell key={`header-${index}`} sx={{ width: col.width }}>
              <Skeleton 
                animation="wave" 
                height={55} 
                sx={{ bgcolor: '#EFEFEF' }}
              />
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
      {Array.from({length: maxRows}, (_, rowIndex) => (
          <TableRow key={`row-${rowIndex}`}>
            {columnsConfig.map((col, colIndex) => (
              <TableCell key={`cell-${rowIndex}-${colIndex}`} sx={{ width: col.width }}>
                {rowIndex < col.rows && (
                  <Skeleton 
                    animation="wave" 
                    height={24} 
                    sx={{ bgcolor: '#EFEFEF' }}
                  />
                )}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}

export default TableSkeleton
